<template>
  <div class="collapse-panel">
    <div class="section-header">
      <div class="header-title">
        <slot name="title"></slot>
        <slot name="port"></slot>
        <slot name="time"></slot>
      </div>
      <Icon
        v-if="!isCollapsed"
        type="chevron-up"
        size="18"
        @click="handleToggle"
        class="icon"
      ></Icon>
      <Icon
        v-if="isCollapsed"
        type="chevron-down"
        size="18"
        @click="handleToggle"
        class="icon"
      ></Icon>
    </div>
    <div v-show="!isCollapsed" class="section-conent">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      default: true,
    },
  },
  data() {
    return {
      // isCollapsed: false,
    };
  },
  methods: {
    handleToggle() {
      this.$emit("input", !this.value);
    },
  },
  computed: {
    isCollapsed() {
      return !this.value;
    },
  },
};
</script>

<style lang="less" scoped>
.collapse-panel {
  .section-header {
    display: flex;
    justify-content: space-between;
    padding-right: 20px;
  }
  .header-title {
    font-size: 16px;
    > span:first-child {
      font-weight: 600;
    }
    > div:first-child {
      font-weight: 600;
    }
  }
  .icon {
    margin-top: 3px;
    z-index:999;
  }
}
</style>



// WEBPACK FOOTER //
// collapse-panel.vue?4c9b4381